module.exports = __webpack_public_path__ + "img/premier-web__mood-board.d679dd58.jpg";